import { IRootState } from '../../../store'
import { IRTSOptionsState } from '../store/options.types'

export const getRtsOptionsSelector = (state: IRootState): IRTSOptionsState => state.options.rtsOptions
